// extracted by mini-css-extract-plugin
export default {"wrap":"DayCounter_wrap__dgQnU","headline":"DayCounter_headline__7XMAB"};